import { EMAIL_REGEX, PASSWORD_REGEX } from '../consts';

export const checkEmail = (email) => {
  return email.match(EMAIL_REGEX);
}

export const checkPassword = (password) => {
  return PASSWORD_REGEX.test(password);
}
